import styled from 'styled-components';
import imageNotAvailable from '../../../images/image_not_available.png';

interface ImageProps {
  src: string | null;
  width: string;
  height: string;
}

const Image = styled.img<ImageProps>`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  src: ${(props) => props.src || imageNotAvailable};
`;

export default Image;
